import React, {useState, useEffect} from "react";
import classnames from "classnames";
import {useMediaQuery} from "react-responsive";
import {HeaderWrapper} from "../HeaderWrapper";
import {Search} from "../Search";
import {Cart} from "../Cart";

import styles from "./sticky-header.module.scss";
import logo from "../../../../assets/images/logo.svg";

export function StickyHeader() {
  const [isShowing, setIsShowing] = useState(false);
  const isMobile = useMediaQuery({maxWidth: 940});

  useEffect(() => {
    function onScroll() {
      if (window.pageYOffset > 100) {
        setIsShowing(true);
      } else {
        setIsShowing(false);
      }
    }
    document.addEventListener(`scroll`, onScroll);
    return () => document.removeEventListener(`scroll`, onScroll);
  }, [isMobile]);

  return (
    <HeaderWrapper
      className={classnames(
        styles.sticky,
        isShowing && !isMobile && styles.show
      )}
    >
      <div className={styles.container}>
        <div className={styles.left}>
          <a href="/" className={styles.logo}>
            <img src={logo} alt="Printio" />
          </a>
          <Search isSticky isShowing={isShowing} />
        </div>
        <div className={styles.right}>
          <Cart forceClosed={!isShowing} />
        </div>
      </div>
    </HeaderWrapper>
  );
}
